// moved the content to another package to be reused by other packages
// keep this file to support existing codes importing this file.
import { constants } from '@bingads-webui-campaign-react/image-experience-model';

export default constants;
